{
  "nav": {
    "pricing": "Prețuri",
    "contact": "Contact",
    "menu": "Meniu",
    "login": "Autentificare",
    "features": "Funcționalități",
    "brandHomeAria": "Done-it — pagina principală",
    "market": {
      "belgium": "Belgia",
      "international": "La nivel mondial"
    }
  },
  "footer": {
    "tagline": "Done-it — Pontaj simplu.",
    "terms": "Termeni",
    "privacy": "Confidențialitate",
    "contact": "Contact"
  },
  "help": "Ai nevoie de ajutor?",
  "continue": "Continuă",
  "back": "Înapoi",
  "change": "Modifică",
  "retry": "Reîncearcă",
  "errors": {
    "unexpected": "Eroare neașteptată"
  },
  "step": {
    "of": "Pasul {{n}} din {{total}}"
  },
  "funnel": {
    "title": "Abonament · Done-it"
  }
}
